import { useEffect, useState } from "react";
import { Menu, PanelLeftClose, PanelLeftOpen } from "lucide-react";

function Topbar({ toggleSidebar }) {
  const [dateTime, setDateTime] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("sidebar_collapsed") === "true";
  });

  // ✅ GET USER
  const user = JSON.parse(localStorage.getItem("user"));

  // ✅ GET INITIALS (FIRST 2 LETTERS)
  const getInitials = (name) => {
    if (!name) return "U";
    return name.substring(0, 2).toUpperCase();
  };

  useEffect(() => {
    const handleCollapseChange = () => {
      setIsCollapsed(localStorage.getItem("sidebar_collapsed") === "true");
    };
    window.addEventListener("sidebarCollapseChanged", handleCollapseChange);
    return () => window.removeEventListener("sidebarCollapseChanged", handleCollapseChange);
  }, []);

  const handleDesktopToggle = () => {
    window.dispatchEvent(new Event("toggleSidebarCollapse"));
  };

  // ✅ LIVE DATE & TIME
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const formatted = now.toLocaleString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      setDateTime(formatted);
    };

    updateTime(); // initial
    const interval = setInterval(updateTime, 1000); // every second

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="topbar">
      <div className="tb-left">
        {/* Mobile Hamburger */}
        <button 
          className="hamburger" 
          onClick={toggleSidebar} 
          aria-label="Toggle Mobile Navigation"
          type="button"
        >
          <Menu size={22} />
        </button>

        {/* Desktop Sidebar Collapse Toggle */}
        <button
          className="tb-desktop-toggle"
          onClick={handleDesktopToggle}
          title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
          aria-label="Toggle Sidebar"
          type="button"
        >
          {isCollapsed ? <PanelLeftOpen size={20} /> : <PanelLeftClose size={20} />}
        </button>

        <div className="tb-title">
          <span className="tb-title-main">Four Leaf</span>
          <span className="tb-title-sub">Job Tracking System</span>
        </div>
      </div>

      <div className="tb-right">
        {/* ✅ LIVE DATE TIME */}
        <div className="tb-chip">{dateTime}</div>

        {/* ✅ USER INITIALS & ROLE */}
        <div 
          className="tb-user-trigger" 
          onClick={() => window.dispatchEvent(new Event("openProfileModal"))}
          title="Open Profile Settings"
        >
          <div className="tb-ava">
            {getInitials(user?.name)}
          </div>
          <div className="tb-user-info-desktop">
            <span className="tb-uname">{user?.name || "User"}</span>
            <span className="tb-urole">{user?.role || "Staff"}</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Topbar;